import { apiClient } from '@/shared/api/client';
import type { AuthenticationResponse, ApiResponse } from '../types/auth.types';

export const backendAuthService = {
  async authenticate(firebaseToken: string): Promise<AuthenticationResponse> {
    const response = await apiClient<ApiResponse<AuthenticationResponse>>('/auth/authenticate', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${firebaseToken}`,
      },
    });
    return response.data;
  },

  async getCurrentUser(): Promise<AuthenticationResponse> {
    const response = await apiClient<ApiResponse<AuthenticationResponse>>('/auth/me', {
      method: 'GET',
    });
    return response.data;
  },
};
